export type RuntimeEnv = Record<string, string | boolean | undefined>;

export type FirebaseWebConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
};

const requiredConfig = {
  apiKey: "VITE_FIREBASE_API_KEY",
  authDomain: "VITE_FIREBASE_AUTH_DOMAIN",
  projectId: "VITE_FIREBASE_PROJECT_ID",
  storageBucket: "VITE_FIREBASE_STORAGE_BUCKET",
  messagingSenderId: "VITE_FIREBASE_MESSAGING_SENDER_ID",
  appId: "VITE_FIREBASE_APP_ID"
} as const;

export function isMockModeEnabled(env: RuntimeEnv): boolean {
  return env.DEV === true && env.VITE_ENABLE_MOCK_AUTH === "true";
}

export function getFirebaseConfig(env: RuntimeEnv): FirebaseWebConfig {
  const missing = Object.values(requiredConfig).filter((key) => !env[key]);
  if (missing.length > 0) {
    throw new Error(`Missing Firebase web config: ${missing.join(", ")}`);
  }
  if (env.VITE_FIREBASE_PROJECT_ID === "crm-pro-ee2ce") {
    throw new Error("CRM Firebase project config is not allowed for LTD Accounting.");
  }
  return {
    apiKey: String(env.VITE_FIREBASE_API_KEY),
    authDomain: String(env.VITE_FIREBASE_AUTH_DOMAIN),
    projectId: String(env.VITE_FIREBASE_PROJECT_ID),
    storageBucket: String(env.VITE_FIREBASE_STORAGE_BUCKET),
    messagingSenderId: String(env.VITE_FIREBASE_MESSAGING_SENDER_ID),
    appId: String(env.VITE_FIREBASE_APP_ID)
  };
}

export function getFunctionsBaseUrl(env: RuntimeEnv): string | null {
  return env.VITE_FUNCTIONS_BASE_URL ? String(env.VITE_FUNCTIONS_BASE_URL) : null;
}
